import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import View from 'shared_features/athlete_popup';
import * as Actions from './actions';
import * as ProfileSelectors from 'shared_redux/selectors/view/profile';

// DEBUG MESSAGE - should appear in console when this file is loaded
console.log('EDIT PROFILE INDEX.JS LOADED');

const getViewModel = createSelector(
    ProfileSelectors.getIsEditing,
    ProfileSelectors.getIsLoadingEmail,
    ProfileSelectors.getGroupId,
    ProfileSelectors.getFirstName,
    ProfileSelectors.getMiddleName,
    ProfileSelectors.getLastName,
    ProfileSelectors.getEmail,
    ProfileSelectors.getInviteStatus,
    ProfileSelectors.getTeamsWithDefaultGroups,
    ProfileSelectors.getDefaultOrgGroupId,
    ProfileSelectors.getSelectedTeamId,
    ProfileSelectors.getGroupsForSelectedTeam,
    (isShowing, isLoadingEmail, groupId, firstName, middleName, lastName, email, inviteStatus, teams, defaultOrgGroupId, selectedTeamId, groups) => {
        console.log('EditProfile getViewModel:', {
            email,
            inviteStatus,
            firstName,
            lastName,
            isLoadingEmail
        });

        return {
            isShowing,
            isLoadingEmail,
            firstName,
            middleName,
            lastName,
            email,
            inviteStatus,
            groupId,
            selectedTeamId,
            teams,
            groups,
            defaultOrgGroupId,
            showAvatarOption: false,
            showRemove: true,
        }
    }
);

const mapStateToProps = (state) => getViewModel(state);

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateFirstName: Actions.updateFirstName,
        updateMiddleName: Actions.updateMiddleName,
        updateLastName: Actions.updateLastName,
        updateTeam: Actions.updateTeam,
        updateGroup: Actions.updateGroup,
        updateEmail: Actions.updateEmail,
        cancelInvite: Actions.cancelInvite,
        remove: Actions.remove,
        save: Actions.save,
        closeModal: Actions.closeModal,
    }, dispatch);
};

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View);

export default Container;
